import React, { useState } from "react";

import { FIELD_TYPE, tabKeys, TT_PHIEU_VTYT } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "../../../../../../types/models/column-table-edit";
import { Button, Popconfirm, Row, Select } from "antd";
import Icons from "../../../../../../assets/icons";
import { EyeOutlined } from "@ant-design/icons";
import {
  startOfMonth,
  endOfMonth,
  eachWeekOfInterval,
  format,
  startOfWeek,
  addWeeks,
  addDays,
} from "date-fns";
import { setLoading } from "redux/reducer/medicineStore";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER, SELECT } =
  FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}
const listWeek = [];
for (let week = 1; week <= 6; week++) {
  listWeek.push({
    value: week,
    label: `Tuần ${week}`,
  });
}
// const dayjs = require('dayjs');
// const changeWeek = (newMonth?: number , newYear?: number) => {
//   const today = dayjs();
//   const firstDayOfMonth = today.date(1);
//   const listWeek = [];
//   const daysInMonth = newMonth
//     ? dayjs(`${newYear || today.year()}-${newMonth}-01`).daysInMonth()
//     : today.daysInMonth();
//   const isLeapYear = (year: number) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
//   for (let i = 0; i < 5; i++) {
//     const weekStartDate = firstDayOfMonth.add(i * 7, 'day');
//     let weekEndDate;

//     if (newMonth === 2 && i === 4) {
//       if (isLeapYear(newYear || today.year())) {
//         weekEndDate = weekStartDate
//       } else {
//         continue;
//       }
//     } else {
//       weekEndDate = i === 4
//         ? weekStartDate.add(1, 'week').subtract(1, 'day')
//         : weekStartDate.add(6, 'day');
//     }

//     if (i === 4) {
//       if(newMonth % 2 !== 0 && newMonth < 8 || newMonth % 2 === 0 && newMonth >= 8)
//       {
//         weekEndDate = weekStartDate.add(2, 'day');
//       }    
//       else
//       {       
//         if (isLeapYear(newYear || today.year())) {
//           weekEndDate = weekStartDate
//         }else
//         {
//           weekEndDate = weekStartDate.add(1, 'day');
//         }

//       }
//     } else {
//       weekEndDate = weekStartDate.add(6, 'day');
//     }
    
//     const formattedStartDate = weekStartDate.format('DD/MM/YYYY');
//     const formattedEndDate = weekEndDate.format('DD/MM/YYYY');
//     let startDate = formattedStartDate;
//     let endDate = formattedEndDate;

//     if (newMonth && !newYear) {
//       startDate = `${formattedStartDate.split('/')[0]}/${newMonth}/${formattedStartDate.split('/')[2]}`;
//       endDate = `${formattedEndDate.split('/')[0]}/${newMonth}/${formattedEndDate.split('/')[2]}`;
//     }

//     if (newYear && !newMonth) {
//       startDate = `${formattedStartDate.split('/')[0]}/${formattedStartDate.split('/')[1]}/${newYear}`;
//       endDate = `${formattedEndDate.split('/')[0]}/${formattedEndDate.split('/')[1]}/${newYear}`;
//     }

//     if (newMonth && newYear) {
//       startDate = `${formattedStartDate.split('/')[0]}/${newMonth}/${newYear}`;
//       endDate = `${formattedEndDate.split('/')[0]}/${newMonth}/${newYear}`;
//     }

//     const weekLabel = `Tuần ${i + 1} (${startDate} - ${endDate})`;
    
//     listWeek.push({
//       value: i + 1,
//       label: weekLabel,
//     });
//   }
//   return listWeek;
// };
//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const generateWeeks = () => {
  const currentMonth = new Date();
  const startOfMonthDate = startOfMonth(currentMonth);
  const endOfMonthDate = endOfMonth(currentMonth);
  return eachWeekOfInterval({ start: startOfMonthDate, end: endOfMonthDate });
};
const allColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Phòng ban",
    key: "tenNhom",
    show: true,
    dataIndex: "tenNhom",
    width: 30,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Mã NV",
    key: "maNv",
    show: true,
    dataIndex: "maNv",
    width: 50,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 50,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Tuần",
    key: "tuan",
    show: true,
    disabledCheck: true,
    dataIndex: "tuan",
    align: "center",
    className: "white",
    // children: [
    //   {
    //     title: "",
    //     key: "rank2",
    //     show: true,
    //     dataIndex: "rank2",
    //     width: 70,
    //     align: "center",
    //     className: "white",

    //     children: [
    //       {
    //         type: "COMBO_BOX",
    //         title: "T2",
    //         key: "thu2",
    //         show: true,
    //         dataIndex: "thu2",
    //         width: 70,
    //         align: "center",
    //         className: "white",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rank3",
    //     show: true,
    //     dataIndex: "rank3",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "T3",
    //         className: "white",
    //         key: "thu3",
    //         show: true,
    //         dataIndex: "thu3",
    //         width: 70,
    //         align: "center",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rank4",
    //     show: true,
    //     dataIndex: "rank4",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "T4",
    //         key: "thu4",
    //         show: true,
    //         dataIndex: "thu4",
    //         width: 70,
    //         align: "center",
    //         className: "white",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rank5",
    //     show: true,
    //     dataIndex: "rank5",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "T5",
    //         className: "white",
    //         key: "thu5",
    //         show: true,
    //         dataIndex: "thu5",
    //         width: 70,
    //         align: "center",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rank6",
    //     show: true,
    //     dataIndex: "rank6",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "T6",
    //         className: "white",
    //         key: "thu6",
    //         show: true,
    //         dataIndex: "thu6",
    //         width: 70,
    //         align: "center",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rank7",
    //     show: true,
    //     dataIndex: "rank7",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "T7",

    //         className: "white",
    //         key: "thu7",
    //         show: true,
    //         dataIndex: "thu7",
    //         width: 70,
    //         align: "center",
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     key: "rankCN",
    //     show: true,
    //     dataIndex: "rankCN",
    //     width: 70,
    //     align: "center",
    //     className: "white",
    //     children: [
    //       {
    //         title: "CN",
    //         className: "white",
    //         key: "chuNhat",
    //         show: true,
    //         dataIndex: "chuNhat",
    //         width: 70,
    //         align: "center",
    //       },
    //     ],
    //   },
    // ],
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng ban",
    name: "idPhongBan",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNv",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
  },
  // {
  //   type: COMBO_BOX,
  //   name: "tuan",
  //   label: "Tuần",
  //   disable: false,
  //   options: listWeek,
  //   css: {
  //     xl: 12,
  //     lg: 12,
  //     md: 12,
  //     sm: 24,
  //     xs: 24,
  //   },
  //   labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
  //   wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
    
  // },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
    options: listMonths,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],
    options: listYears,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 4, xl: 4 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 20 },
  },
];

export { allColumns, itemsInputField};
